<template>
  <v-dialog v-model="visible" max-width="560" persistent class="gm-dialog">
    <v-card class="rounded-30 overflow-hidden dialog-card">
      <div class="gm-dialog-header d-flex align-center px-8 py-5">
        <div class="text-h5">
          <span style="color: #2655f1">确认</span>
          <span>投运</span>
        </div>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" :disabled="submitting" @click="onCancel" />
      </div>

      <v-card-text class="px-8 pt-0 pb-4">
        <div class="section-hint text-body-2 mb-4">
          投运后电站将进入运行状态，请确认基本信息、设备与拓扑均已检查无误。
        </div>
        <div class="confirm-tip">
          <span>确认对 </span>
          <span class="confirm-tip__name">{{ stationName || '该电站' }}</span>
          <span> 完成审核并投运吗？</span>
        </div>
      </v-card-text>

      <v-card-actions class="px-8 pb-6 pt-0 justify-end">
        <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-8 mr-3" :disabled="submitting"
          @click="onCancel">
          取消
        </v-btn>
        <v-btn color="#2655f1" variant="flat" class="gm-btn-primary text-white px-8" :loading="submitting"
          @click="onConfirm">
          确认投运
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  stationName: {
    type: String,
    default: '',
  },
  submitting: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:modelValue', 'confirm'])

const visible = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})

function onCancel() {
  visible.value = false
}

function onConfirm() {
  emit('confirm')
}
</script>

<style scoped lang="scss">
/* 与 ApproveRejectDialog / system-manager/config/ProductModel/_dialog-styles.scss 一致的视觉规范 */

.gm-dialog {
  :deep(.v-overlay__content) {
    border-radius: 30px !important;
  }
}

.dialog-card {
  border-radius: 30px !important;
  background: #fff;
}

.gm-dialog-header {
  background: linear-gradient(185deg, #2655f160 0%, #fff0 60%);
  position: relative;

  .text-h5 {
    font-size: 22px !important;
    font-weight: 500;
  }
}

.section-hint {
  color: rgba(46, 46, 46, 0.6);
  line-height: 1.6;
}

.confirm-tip {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 1.6;

  &__name {
    font-weight: 600;
    color: #2655f1;
    word-break: break-all;
  }
}

.gm-btn-secondary {
  height: 42px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #545454 !important;
  box-shadow: none !important;
}

.gm-btn-primary {
  height: 42px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  box-shadow: none !important;
}
</style>
